import { store } from '@betacrew/jars-flux'
import { PAGE_STATE } from '../../constants/constants';
export const componentKey = "MEMBER_ACCEPT_INVITATION";

const initialAcceptInvitationFormFields = {
    Email: "",
    Token: "",
    Password: "",
    ConfirmPassword: "",
    CountryCode: "+1",
    PhoneNumber: "",
    GRecaptchaResponse: "",
}

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        updateAcceptInvitationFormFields: (state, action) => {
            state.acceptInvitationFormFields = {
                ...state.acceptInvitationFormFields,
                ...action.payload,
            }
        },
        setLoadingState: (state, action) => {
            state.loadingState = action.payload
        },
        setValidResetToken: (state, action) => {
            state.validResetToken = action.payload;
        },
        setIsAcceptInvitationSuccess: (state, action) => {
            state.isAcceptInvitationSuccess = action.payload;
        },
        resetAcceptInvitationFormFields: (state, action) => {
            state.acceptInvitationFormFields = initialAcceptInvitationFormFields;
        },
        setSelectedCountry: (state, action) => {
            state.selectedCountry = action.payload;
        }
    }, 
    initialReducerState: {
        acceptInvitationFormFields : initialAcceptInvitationFormFields,
        loadingState: { state: PAGE_STATE.PAGE_READY, message: "" },
        validResetToken: false,
        isAcceptInvitationSuccess: false,
        selectedCountry: {
            label: "United States",
            value: "+1",
            code: "US"
        },
    }
});
export const { updateAcceptInvitationFormFields, setLoadingState, setValidResetToken, setIsAcceptInvitationSuccess, resetAcceptInvitationFormFields, setSelectedCountry } = actions;
